import { useEventStore } from './event.store'
import { useEventBucketStore } from './eventBucket.store'
import type { DateSelectorWithTimes } from '@/models'

export const useEventDateSelector = defineStore(
  'eventDateSelector.store',
  () => {
    const eventBucketStore = useEventBucketStore()
    const eventStore = useEventStore()
    const {
      getDateSelectorsFromEntity,
      createDateSelectors,
      getDatesByMonths,
    } = useDateSelector()

    const eventDateSelectors = computed(() => {
      const activeEvent = eventStore.event!
      const events = getDateSelectorsFromEntity(
        eventBucketStore.currentEventBucket?.events || [],
      )

      return createDateSelectors(events, activeEvent)
    })
    const eventDateSelectorsPerMonth = computed(
      (): { [key: string]: DateSelectorWithTimes[] } => {
        return getDatesByMonths(eventDateSelectors.value)
      },
    )

    return {
      eventDateSelectors,
      eventDateSelectorsPerMonth,
    }
  },
)
